
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as chateKmnEFwJ5o2R6TOzU3bpX30sz2uJhzQGOhtdv7l7BnEMeta } from "/opt/atlassian/pipelines/agent/build/pages/chat.vue?macro=true";
import { default as callsAVClo3zC7911zlB7buLhEdMurAHRvPP7MfTTcwtaMaUMeta } from "/opt/atlassian/pipelines/agent/build/pages/calls.vue?macro=true";
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta } from "/opt/atlassian/pipelines/agent/build/pages/login.vue?macro=true";
import { default as musicJjTi2PRC_45ZFDeGDdX4DbB0mBUEYKyjbiufZTBi6pU8EMeta } from "/opt/atlassian/pipelines/agent/build/pages/music.vue?macro=true";
import { default as signupa_454KIVcUi1rCGNXnMW4kc3Shrduc030eDtNsTCfX9ZgMeta } from "/opt/atlassian/pipelines/agent/build/pages/signup.vue?macro=true";
import { default as discover8eXx5Z9jeDZVLJGFME1SKCm9ToZ_AQx8dM3uf3M6kosMeta } from "/opt/atlassian/pipelines/agent/build/pages/discover.vue?macro=true";
import { default as feedbackr5RMrZChsFVafCTUtAc1aRS0OR_45ofY00q42WSIEcTs4Meta } from "/opt/atlassian/pipelines/agent/build/pages/feedback.vue?macro=true";
import { default as wishlistVrBmsmPKc08HWVAHJFcEHhX2_EixFd5LiYdIqNxgzjkMeta } from "/opt/atlassian/pipelines/agent/build/pages/wishlist.vue?macro=true";
import { default as dashboardjCm8x0vIO2JRC6YkJLYIbDyBSQi5nyAEb_8t_45C91IjMMeta } from "/opt/atlassian/pipelines/agent/build/pages/dashboard.vue?macro=true";
import { default as index_45oldGyfDvGWu_45Udt_Rq_45CjOi1dVmQLf0MJvAhanAfnVScJsMeta } from "/opt/atlassian/pipelines/agent/build/pages/index-old.vue?macro=true";
import { default as impersonateWNpAZvIzgSAh9sR83Ccw68Lz9ennB6zql0yDyK1yp0oMeta } from "/opt/atlassian/pipelines/agent/build/pages/impersonate.vue?macro=true";
import { default as _91uniqueName_93SxUoMrN72NW02MRlTpn1eR_45bUBrzw_yYkz5ks8YS8gkMeta } from "/opt/atlassian/pipelines/agent/build/pages/[uniqueName].vue?macro=true";
import { default as indexvcyq59iYsh3Qn1Ju8t_45maAwKv7tWOprVQNMFPd9DkdsMeta } from "/opt/atlassian/pipelines/agent/build/pages/submit/index.vue?macro=true";
import { default as track_45iKZ56PqSBt_45JM3TppfeR_OPBYMnIXVG0VeXkqDeiI8Meta } from "/opt/atlassian/pipelines/agent/build/pages/submit/track.vue?macro=true";
import { default as _91orderId_93gsehBO71UgQVAkVpeKO3vpegfN2WPvNh6EZ1ziyTBoUMeta } from "/opt/atlassian/pipelines/agent/build/pages/call/[orderId].vue?macro=true";
import { default as profileBl7Wb76KI0OTYYhFsQLlRsCpelQbOr1cAbTFGzGTXewMeta } from "/opt/atlassian/pipelines/agent/build/pages/submit/profile.vue?macro=true";
import { default as successpiwsAhc7YTZc9BCLkfUj5Ckj_ZCgzK7gnu8cz2R79w0Meta } from "/opt/atlassian/pipelines/agent/build/pages/submit/success.vue?macro=true";
import { default as post_45onboardingg7T1Hk4leK4wVrGOwSX3gUwwvDOttTRHb7ASC8nXW7gMeta } from "/opt/atlassian/pipelines/agent/build/pages/post-onboarding.vue?macro=true";
import { default as _91type_93_45dashboard2DtYL07BwidlGgNAm6dlFP7u29Yq8Exe53eUQfxFkb8Meta } from "/opt/atlassian/pipelines/agent/build/pages/[type]-dashboard.vue?macro=true";
import { default as success3zmKP_45UZAL99QRpIFfKocKCyYGYSH1Xs55Nh677l01YMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/success.vue?macro=true";
import { default as my_45_91type_93_45profileayZfZbZ1H1LbkmYSZc__45b8wjCRHk_455ywYnriy8nlt5wMeta } from "/opt/atlassian/pipelines/agent/build/pages/my-[type]-profile.vue?macro=true";
import { default as pay_45Kj7sLX7KzQZofX_45YlLDgwK1zokBJLTc935_45wnHmGXUMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/pay.vue?macro=true";
import { default as revieww9tzqYbY3H3_45wzOxEt9YfuJ5zlPAc7E6smIYDhfYF8MMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/review.vue?macro=true";
import { default as pick_45time6raprhjkfRuZ596vgI1gc1JE8PFu02JpKXAmMtsDJ4QMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/pick-time.vue?macro=true";
import { default as phone_45numberg6_07GsVasPhxMNgseW0331M2q4z6yN8Kg8kHF0HpZYMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/phone-number.vue?macro=true";
import { default as select_45stageHGm3BEieDmaENtZRg_45laFyv_Cup9PB7oc5aFd1f9EBEMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/select-stage.vue?macro=true";
import { default as select_45trackG6izrZL9ZNpcl379InGzsqSnbbtHkbJY1OHfBTiI07sMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/select-track.vue?macro=true";
import { default as extra_45contentcLdBAeYSD5VV_45vasBzU53EncvSCshcAus4OSTiuJaVEMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/extra-content.vue?macro=true";
import { default as about_45yourselfubTurMoJ_45eFfeWlRA9EuLLNfVmVhBZsEmo5IDl_45cHqUMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/about-yourself.vue?macro=true";
import { default as feedback_45topictTXvEz6bS3G5VABWEmQMmp8Yl7uq_cDVZ6LToBAS6_sMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/feedback-topic.vue?macro=true";
import { default as checkoutPaK1vknpqXBQuxyAOueE8vbxl0jymRB_45_45F4bfkcdSQUMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/checkout.vue?macro=true";
import { default as xposure_45playlistsB_haSvGuR7FCtAZbhbW9uS76J5sJt40B4l1HUO5BfDsMeta } from "/opt/atlassian/pipelines/agent/build/pages/xposure-playlists.vue?macro=true";
import { default as _91uniqueName_93_4545kPsZdBGj_45uZL5CUeadCWb6JRnSN0nTvw_45VZAy0l4Meta } from "/opt/atlassian/pipelines/agent/build/pages/artist/[uniqueName].vue?macro=true";
import { default as indexftYSOX2crhUFYoQuxwzsIx1mmFc8zgODp0G2v_45U00w4Meta } from "/opt/atlassian/pipelines/agent/build/pages/industry-pros/index.vue?macro=true";
import { default as successzugMYD91Z4IG8gEuC0lmdQTVCsrqvbbM0o3o6pxUpDYMeta } from "/opt/atlassian/pipelines/agent/build/pages/opportunity/success.vue?macro=true";
import { default as demo_45submissions_45oldc_gbW9ojvwXiFZiP8s9h0pAz5b4evJy4gFaFeH4RHioMeta } from "/opt/atlassian/pipelines/agent/build/pages/demo-submissions-old.vue?macro=true";
import { default as errordnKoBfkY__0oOA4BMoJEjghyYkdqV_zZ1mD0xY14GPoMeta } from "/opt/atlassian/pipelines/agent/build/pages/pro-onboarding/error.vue?macro=true";
import { default as _91uniqueName_93o_45_ahiQ2jX6LZTY3y_Ruhu8nH_rnuMn0H3u4X13j0XAMeta } from "/opt/atlassian/pipelines/agent/build/pages/purchase/[uniqueName].vue?macro=true";
import { default as indexIZFuwyesbOBsabjewrGZgFnEvCjeGijCisMUAkPE6U8Meta } from "/opt/atlassian/pipelines/agent/build/pages/my-opportunities/index.vue?macro=true";
import { default as _91_46_46_46slugs_93vpS7VCwBwc72b4fdmoLM9MaSLjDuM9x4hs_JnBLZAH0Meta } from "/opt/atlassian/pipelines/agent/build/pages/industry-pros/[...slugs].vue?macro=true";
import { default as _91uniqueId_936VP_45HhbDPhxsCU3C_AH7py_45J48JWrwqzb5Ym6jZ_4521QMeta } from "/opt/atlassian/pipelines/agent/build/pages/pro-onboarding/[uniqueId].vue?macro=true";
import { default as indexcNV6JLE0b1PJ3Q__JYKyK4nX9Qp0blPtMyTYBEjDcaoMeta } from "/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/index.vue?macro=true";
import { default as indexCZbHerZL4dIRQ5fLv11sL5pujOB80MH6JWKM_45F_w5nUMeta } from "/opt/atlassian/pipelines/agent/build/pages/apply-as-industry-pro/index.vue?macro=true";
import { default as profileHUYVZUoM1fTC13f8mpiiDOwvSRt3UHxfBZ4vBJp1EjYMeta } from "/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/profile.vue?macro=true";
import { default as questionU6cAkaCeLW_45GRgKGKpuUBq_451vV0J1SGnuAHjZLBHulwMeta } from "/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/question.vue?macro=true";
import { default as select_45track243wMqv2mg_W8Zvs6PoqJrP_45oiF0N5YCF_KXOgo9DygMeta } from "/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/select-track.vue?macro=true";
import { default as _91opportunityId_938unfvpU4jA6D3hrRoik7TjHPExL94yCJ7pyi64xbNEUMeta } from "/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId].vue?macro=true";
import { default as _91requestId_93FuktdCmKrCoY8Hocbwj0YMYbzniU2O7pOyawKeMsFuwMeta } from "/opt/atlassian/pipelines/agent/build/pages/rating/[userId]/[requestId].vue?macro=true";
import { default as success_45TxaGyHAhFvMG7y4OgTK8tQdo6DlzUDLpLfH4IRVTaMMeta } from "/opt/atlassian/pipelines/agent/build/pages/apply-as-industry-pro/success.vue?macro=true";
import { default as _91opportunitySlug_93SM0W9JisdkKJpzt0ZK4G8KKlWSTW26kVT_clOCy2D9oMeta } from "/opt/atlassian/pipelines/agent/build/pages/my-opportunities/[opportunitySlug].vue?macro=true";
import { default as _91opportunitySubmissionId_937Tx1C0fGYYvKRy_45DyEBfjovqQaTnz_66KIoYPmCn1foMeta } from "/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/[opportunitySlug]/[opportunitySubmissionId].vue?macro=true";
import { default as _91opportunitySlug_93ibDcDfFsjiwXsgB8zF7XcMLrnVQMVcrraB8upPqm3rMMeta } from "/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/[opportunitySlug].vue?macro=true";
import { default as component_45stubQjLgDlVXkjyftxcHmlViFKymK7nsRtZRE8rDZfYRHbgMeta } from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQjLgDlVXkjyftxcHmlViFKymK7nsRtZRE8rDZfYRHbg } from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "chat",
    path: "/chat",
    meta: chateKmnEFwJ5o2R6TOzU3bpX30sz2uJhzQGOhtdv7l7BnEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/chat.vue")
  },
  {
    name: "calls",
    path: "/calls",
    meta: callsAVClo3zC7911zlB7buLhEdMurAHRvPP7MfTTcwtaMaUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/calls.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "music",
    path: "/music",
    meta: musicJjTi2PRC_45ZFDeGDdX4DbB0mBUEYKyjbiufZTBi6pU8EMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/music.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/signup.vue")
  },
  {
    name: "discover",
    path: "/discover",
    meta: discover8eXx5Z9jeDZVLJGFME1SKCm9ToZ_AQx8dM3uf3M6kosMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/discover.vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    meta: feedbackr5RMrZChsFVafCTUtAc1aRS0OR_45ofY00q42WSIEcTs4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/feedback.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    meta: wishlistVrBmsmPKc08HWVAHJFcEHhX2_EixFd5LiYdIqNxgzjkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/wishlist.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardjCm8x0vIO2JRC6YkJLYIbDyBSQi5nyAEb_8t_45C91IjMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dashboard.vue")
  },
  {
    name: "index-old",
    path: "/index-old",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index-old.vue")
  },
  {
    name: "impersonate",
    path: "/impersonate",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/impersonate.vue")
  },
  {
    name: "uniqueName",
    path: "/:uniqueName()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[uniqueName].vue")
  },
  {
    name: "submit",
    path: "/submit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/submit/index.vue")
  },
  {
    name: "submit-track",
    path: "/submit/track",
    meta: track_45iKZ56PqSBt_45JM3TppfeR_OPBYMnIXVG0VeXkqDeiI8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/submit/track.vue")
  },
  {
    name: "call-orderId",
    path: "/call/:orderId()",
    meta: _91orderId_93gsehBO71UgQVAkVpeKO3vpegfN2WPvNh6EZ1ziyTBoUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/call/[orderId].vue")
  },
  {
    name: "submit-profile",
    path: "/submit/profile",
    meta: profileBl7Wb76KI0OTYYhFsQLlRsCpelQbOr1cAbTFGzGTXewMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/submit/profile.vue")
  },
  {
    name: "submit-success",
    path: "/submit/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/submit/success.vue")
  },
  {
    name: "post-onboarding",
    path: "/post-onboarding",
    meta: post_45onboardingg7T1Hk4leK4wVrGOwSX3gUwwvDOttTRHb7ASC8nXW7gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/post-onboarding.vue")
  },
  {
    name: "type-dashboard",
    path: "/:type()-dashboard",
    meta: _91type_93_45dashboard2DtYL07BwidlGgNAm6dlFP7u29Yq8Exe53eUQfxFkb8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[type]-dashboard.vue")
  },
  {
    name: "purchase-success",
    path: "/purchase/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/success.vue")
  },
  {
    name: "my-type-profile",
    path: "/my-:type()-profile",
    meta: my_45_91type_93_45profileayZfZbZ1H1LbkmYSZc__45b8wjCRHk_455ywYnriy8nlt5wMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-[type]-profile.vue")
  },
  {
    name: "purchase-checkout",
    path: "/purchase/checkout",
    meta: checkoutPaK1vknpqXBQuxyAOueE8vbxl0jymRB_45_45F4bfkcdSQUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout.vue"),
    children: [
  {
    name: "purchase-checkout-pay",
    path: "pay",
    meta: pay_45Kj7sLX7KzQZofX_45YlLDgwK1zokBJLTc935_45wnHmGXUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/pay.vue")
  },
  {
    name: "purchase-checkout-review",
    path: "review",
    meta: revieww9tzqYbY3H3_45wzOxEt9YfuJ5zlPAc7E6smIYDhfYF8MMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/review.vue")
  },
  {
    name: "purchase-checkout-pick-time",
    path: "pick-time",
    meta: pick_45time6raprhjkfRuZ596vgI1gc1JE8PFu02JpKXAmMtsDJ4QMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/pick-time.vue")
  },
  {
    name: "purchase-checkout-phone-number",
    path: "phone-number",
    meta: phone_45numberg6_07GsVasPhxMNgseW0331M2q4z6yN8Kg8kHF0HpZYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/phone-number.vue")
  },
  {
    name: "purchase-checkout-select-stage",
    path: "select-stage",
    meta: select_45stageHGm3BEieDmaENtZRg_45laFyv_Cup9PB7oc5aFd1f9EBEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/select-stage.vue")
  },
  {
    name: "purchase-checkout-select-track",
    path: "select-track",
    meta: select_45trackG6izrZL9ZNpcl379InGzsqSnbbtHkbJY1OHfBTiI07sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/select-track.vue")
  },
  {
    name: "purchase-checkout-extra-content",
    path: "extra-content",
    meta: extra_45contentcLdBAeYSD5VV_45vasBzU53EncvSCshcAus4OSTiuJaVEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/extra-content.vue")
  },
  {
    name: "purchase-checkout-about-yourself",
    path: "about-yourself",
    meta: about_45yourselfubTurMoJ_45eFfeWlRA9EuLLNfVmVhBZsEmo5IDl_45cHqUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/about-yourself.vue")
  },
  {
    name: "purchase-checkout-feedback-topic",
    path: "feedback-topic",
    meta: feedback_45topictTXvEz6bS3G5VABWEmQMmp8Yl7uq_cDVZ6LToBAS6_sMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/checkout/feedback-topic.vue")
  }
]
  },
  {
    name: "xposure-playlists",
    path: "/xposure-playlists",
    meta: xposure_45playlistsB_haSvGuR7FCtAZbhbW9uS76J5sJt40B4l1HUO5BfDsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/xposure-playlists.vue")
  },
  {
    name: "artist-uniqueName",
    path: "/artist/:uniqueName()",
    meta: _91uniqueName_93_4545kPsZdBGj_45uZL5CUeadCWb6JRnSN0nTvw_45VZAy0l4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/artist/[uniqueName].vue")
  },
  {
    name: "industry-pros",
    path: "/industry-pros",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/industry-pros/index.vue")
  },
  {
    name: "opportunity-success",
    path: "/opportunity/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/opportunity/success.vue")
  },
  {
    name: "demo-submissions-old",
    path: "/demo-submissions-old",
    meta: demo_45submissions_45oldc_gbW9ojvwXiFZiP8s9h0pAz5b4evJy4gFaFeH4RHioMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/demo-submissions-old.vue")
  },
  {
    name: "pro-onboarding-error",
    path: "/pro-onboarding/error",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/pro-onboarding/error.vue")
  },
  {
    name: "purchase-uniqueName",
    path: "/purchase/:uniqueName()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/purchase/[uniqueName].vue")
  },
  {
    name: "my-opportunities",
    path: "/my-opportunities",
    meta: indexIZFuwyesbOBsabjewrGZgFnEvCjeGijCisMUAkPE6U8Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-opportunities/index.vue")
  },
  {
    name: "industry-pros-slugs",
    path: "/industry-pros/:slugs(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/industry-pros/[...slugs].vue")
  },
  {
    name: "pro-onboarding-uniqueId",
    path: "/pro-onboarding/:uniqueId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/pro-onboarding/[uniqueId].vue")
  },
  {
    name: "my-opportunities-old",
    path: "/my-opportunities-old",
    meta: indexcNV6JLE0b1PJ3Q__JYKyK4nX9Qp0blPtMyTYBEjDcaoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/index.vue")
  },
  {
    name: "apply-as-industry-pro",
    path: "/apply-as-industry-pro",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/apply-as-industry-pro/index.vue")
  },
  {
    name: "opportunity-opportunityId",
    path: "/opportunity/:opportunityId()",
    meta: _91opportunityId_938unfvpU4jA6D3hrRoik7TjHPExL94yCJ7pyi64xbNEUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId].vue"),
    children: [
  {
    name: "opportunity-opportunityId-profile",
    path: "profile",
    meta: profileHUYVZUoM1fTC13f8mpiiDOwvSRt3UHxfBZ4vBJp1EjYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/profile.vue")
  },
  {
    name: "opportunity-opportunityId-question",
    path: "question",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/question.vue")
  },
  {
    name: "opportunity-opportunityId-select-track",
    path: "select-track",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/opportunity/[opportunityId]/select-track.vue")
  }
]
  },
  {
    name: "rating-userId-requestId",
    path: "/rating/:userId()/:requestId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/rating/[userId]/[requestId].vue")
  },
  {
    name: "apply-as-industry-pro-success",
    path: "/apply-as-industry-pro/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/apply-as-industry-pro/success.vue")
  },
  {
    name: "my-opportunities-opportunitySlug",
    path: "/my-opportunities/:opportunitySlug()",
    meta: _91opportunitySlug_93SM0W9JisdkKJpzt0ZK4G8KKlWSTW26kVT_clOCy2D9oMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-opportunities/[opportunitySlug].vue")
  },
  {
    name: "my-opportunities-old-opportunitySlug",
    path: "/my-opportunities-old/:opportunitySlug()",
    meta: _91opportunitySlug_93ibDcDfFsjiwXsgB8zF7XcMLrnVQMVcrraB8upPqm3rMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/[opportunitySlug].vue"),
    children: [
  {
    name: "my-opportunities-old-opportunitySlug-opportunitySubmissionId",
    path: ":opportunitySubmissionId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/my-opportunities-old/[opportunitySlug]/[opportunitySubmissionId].vue")
  }
]
  },
  {
    name: component_45stubQjLgDlVXkjyftxcHmlViFKymK7nsRtZRE8rDZfYRHbgMeta?.name,
    path: "/demo-submissions",
    component: component_45stubQjLgDlVXkjyftxcHmlViFKymK7nsRtZRE8rDZfYRHbg
  }
]